/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module ProductDetails
define(
	'ProductDetails.Quantity.View'
,	[
		'LiveOrder.Model'

	,	'product_details_quantity.tpl'

	,	'Backbone'
	,	'underscore'
	,	'jQuery'
	]
,	function (
		LiveOrderModel

	,	product_details_quantity_tpl

	,	Backbone
	,	_
	,	jQuery
	)
{
	'use strict';

	// @class ProductDetails.Quantity.View @extends Backbone.View
	return Backbone.View.extend({

			template: product_details_quantity_tpl

		,	events: {
				'click [data-action="updateQuantity"]': 'setQuantity'
			,	'click [data-action="changeQuantity"]': 'setFocus'
            ,   'keyup [data-action="changeQuantity"]': 'disableFocus'
			, 	'change [data-action="changeQuantity"]': 'changeQuantity'
			,	'change [name="unitstype"]': 'setUnitstype'
			}

			// @method setQuantity Increase the product's Quantity by 1
			// @param {jQuery.Event} e
			// @return {Void}
		,	setQuantity: function setQuantity (e)
			{
				e.preventDefault();

				var value = parseInt(this.$(e.currentTarget).data('value'), 10)
				,	$input_quantity = this.$('[name="quantity"]')
				,	old_value = parseInt($input_quantity.val(), 10)
				,	new_quantity = old_value + value;

				$input_quantity.val(new_quantity).trigger('blur');
			}
			
		,	changeQuantity: function(e)
			{
				var value = parseInt(this.$(e.target).val()) || 1
				,	$input_quantity = this.$('[name="quantity"]');
				if(value != null && value !='')
				$input_quantity.val(value).trigger('blur');
				this.$('[name="unitstype"]').trigger('change');
			}	
			// @method setFocus sets focus on input when clicked. Needed as FF won't focus if quantity is updated from spinners
			// @return {Void}
		,	setFocus: function setFocus ()
			{
				this.$('[name="quantity"]').focus();
				//this.$('[name="unitstype"]').trigger('change');
			}

			// @method disableFocus Blur if ENTER/RETURN key is pressed
			// @return {Void}
        ,   disableFocus: function disableFocus(e)
            {
                if (e.keyCode === 13)
                {
                    this.$('[name="quantity"]').blur();
                }
            }
		
		,	setUnitstype: function(e)
			{
				e.stopPropagation();
				
				var cartOptionId = jQuery(e.target).data('cart-option-id')
				,	value = jQuery(e.target).find('option:selected').val()
				,	text = jQuery(e.target).find('option:selected').text().trim()
			//	,	text = uomText.substr(0,uomText.lastIndexOf(' '))
				,	saleUnitObj = _.findWhere(this.model.get('item').get('unitstype'), {saleUnit: true})
				,	self = this
				,	customprice;
				
				_.each(this.model.get('item').get('unitstype'), function(unit){
					
					if(unit.id == value)
					{
						//var customprice = parseInt(unit.convertionRate) * self.model.getPrice().price;
						customprice = (self.model.getPrice().price / saleUnitObj.convertionRate) * unit.convertionRate;
						self.model.get('item').set('customprice',customprice);
					}
				});
				_.each( this.model.get('options').models, function(model){

					if(model.get('cartOptionId') == cartOptionId)
					{
						model.set('value',{
							label:value
						,	internalid: value
						});
						self.model.set(cartOptionId,value);
					}
					if(model.get('cartOptionId') == 'custcol_appf_custom_uom_label_website')
					{
						model.set('value',{
							label: text
						,	internalid: text
						});
						self.model.set('custcol_appf_custom_uom_label_website',text);
					}
					if(model.get('cartOptionId') == 'custcol_appf_custom_uom_price_website')
					{
						model.set('value',{
						label: customprice.toString()
						,	internalid: customprice.toString()
						});
						self.model.set('custcol_appf_custom_uom_price_website',customprice.toString());
					}
				});
			}
		
			//@method getContext
			//@return {ProductDetails.Quantity.View.Context}
		,	getContext: function getContext ()
			{
				//@class ProductDetails.Quantity.View.Context
				return {
					//@property {Product.Model} model
					model: this.model
					//@property {Boolean} showQuantity
				,	showQuantity: this.model.get('item').get('_itemType') !== 'GiftCert'
					//@property {Boolean} isMinusButtonDisabled
				,	isMinusButtonDisabled: this.model.get('quantity') <= 1				
				//@property {String} unitType
				//,	unitType:  this.model.get('item').get('saleunit')
				
				,	unitType:  this.model.get('item').get('unitstype')
				
				,	uomExists:(this.model.get('item').get('unitstype') && this.model.get('item').get('unitstype').length > 0)?true:false
				};
				//@class ProductDetails.Quantity.View
			}
		});
});

